<template>
  <div>
    <div class="senv mr20 mb25 ofhidden prelative cpointer dinline-block" v-for="(item,index) in list" :key="item.id">
      <div class="fbg p100 pabsolute twhite tright trans3">
        <div class="fs16 fbold mr25 mb5 mt20 ml20">{{item.title}}</div>
        <div class="fs13 mr25 ml20" v-if="item.description>''">摄影：{{item.description}}</div>
        <div class="pabsolute br50 bg-red tcenter">
        </div>
      </div>
      <img class="img trans3" :src="item['picture'][0]" width="305" height="200" />
    </div>
  </div>
</template>

<script>
import Viewer from "../../../static/viewer/viewer.min.js";
import Start from '../../../static/viewer/start.js'
export default {
  name: "NevItem",
  props:[
    'list'
  ],
  updated() {
    console.log(this.list)
    this.$nextTick(function(){
      var viewer = new Viewer(document.getElementById('viewer'), {
        url: 'src'
      });
      Start.start();
    })
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/un_index/NevItem.vue